import { createClient } from '@/lib/supabase/server';
import { redirect } from 'next/navigation';
import { OnboardingPackClient } from './client';

export default async function OnboardingPackPage() {
  const supabase = await createClient();
  
  // Get the current user
  const { data: { user }, error: userError } = await supabase.auth.getUser();
  
  if (userError || !user) {
    redirect('/login');
  }
  
  // Get profile data
  const { data: profile, error: profileError } = await supabase
    .from('profiles')
    .select('*')
    .eq('id', user.id)
    .single();
  
  if (profileError || !profile) {
    redirect('/worker/profile');
  }
  
  // Get worker profile data
  const { data: workerProfile, error: workerError } = await supabase
    .from('worker_profiles')
    .select('*')
    .eq('profile_id', user.id)
    .single();
  
  if (workerError || !workerProfile) {
    redirect('/worker/profile');
  }
  
  // Prepare data for the client component
  const workerData = {
    name: profile.full_name || '',
    phone: profile.phone || '',
    email: profile.email || '',
    address: profile.address || '',
    suburb: profile.suburb || '',
    trade: workerProfile.trades?.[0] || '',
    experience: workerProfile.experience_years ? `${workerProfile.experience_years} years` : '',
    abn: workerProfile.abn || ''
  };
  
  return (
    <div className="container mx-auto px-4 py-8 max-w-2xl">
      <h1 className="text-3xl font-bold mb-2">Create Onboarding Pack</h1>
      <p className="text-gray-600 mb-8">
        Generate a professional PDF pack with your details for contractors
      </p>
      
      <OnboardingPackClient workerData={workerData} />
    </div>
  );
}